import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Button, Col, Form, Row } from "react-bootstrap";
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { RouterStateButton } from '../forms/elements';
import Logo from '../Logo';
import { Loading } from '../state';
import { OfflinePreview } from './OfflinePreview';

var OfflineShop = function OfflineShop(props) {
  var _props$searchRetailPr = props.searchRetailProduct,
      searchRetailProduct = _props$searchRetailPr === void 0 ? function () {
    return console.log("searchRetailProduct");
  } : _props$searchRetailPr,
      _props$clearRetailSta = props.clearRetailStates,
      clearRetailStates = _props$clearRetailSta === void 0 ? function () {
    return console.log("clearRetailStates");
  } : _props$clearRetailSta,
      _props$addItemsToCart = props.addItemsToCart,
      addItemsToCart = _props$addItemsToCart === void 0 ? function () {
    return console.log("addItemsToCart");
  } : _props$addItemsToCart,
      _props$retailProducts = props.retailProducts,
      retailProducts = _props$retailProducts === void 0 ? [] : _props$retailProducts,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$resetAssign = props.resetAssign,
      resetAssign = _props$resetAssign === void 0 ? function () {
    return console.log("resetting customer");
  } : _props$resetAssign;
  var history = useHistory();

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchKey = _useState2[0],
      setSearchKey = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      goToCart = _useState4[0],
      setGoToCart = _useState4[1];

  useEffect(function () {
    setSearchKey('');
    searchRetailProduct(searchKey);
    clearRetailStates();
  }, []);

  var addToCart = function addToCart(event, cartItem, variant) {
    addItemsToCart(cartItem, variant);
    resetAssign();
    setGoToCart(true);
  };

  var searchProduct = function searchProduct() {
    searchRetailProduct(searchKey);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "offline_container"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "9",
    xs: "9"
  }, /*#__PURE__*/React.createElement(Form.Control, {
    className: "offline_search",
    size: "lg",
    type: "text",
    onChange: function onChange(e) {
      return setSearchKey(e.target.value);
    },
    placeholder: "Search Products",
    onKeyPress: function onKeyPress(event) {
      if (event.key === 'Enter') searchProduct();
    }
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "3",
    xs: "3"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: "cb-button-primary offline-button-search",
    onClick: searchProduct
  }, "Search"))))), /*#__PURE__*/React.createElement(Row, null, loading && /*#__PURE__*/React.createElement("div", {
    className: "cb-l-container-wrapper--space"
  }, /*#__PURE__*/React.createElement(Loading, {
    isLoading: loading
  })), !loading && (retailProducts === null || retailProducts === void 0 ? void 0 : retailProducts.length) > 0 && /*#__PURE__*/React.createElement(Table, {
    className: "offline-table",
    striped: true,
    bordered: true,
    hover: true
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Product Id"), /*#__PURE__*/React.createElement("th", null, "Product Name"), /*#__PURE__*/React.createElement("th", null, "Product Description"), /*#__PURE__*/React.createElement("th", null, "Price"), /*#__PURE__*/React.createElement("th", null, "Available Inventory"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, retailProducts === null || retailProducts === void 0 ? void 0 : retailProducts.map(function (item, index) {
    return item.Variants && item.Variants.length > 0 ? item.Variants.map(function (variant) {
      return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, variant.ProductVariantId), /*#__PURE__*/React.createElement("td", null, variant.ProductVariantDisplayname), /*#__PURE__*/React.createElement("td", null, item.Description), /*#__PURE__*/React.createElement("td", null, variant.AdjustedPrice), /*#__PURE__*/React.createElement("td", null, variant.AvailableInventory), /*#__PURE__*/React.createElement("td", null, variant.StockStatusNameLong), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        disabled: variant.AvailableInventory > 0 ? false : true,
        style: {
          float: 'right'
        },
        className: "cb-button-primary",
        onClick: function onClick(event) {
          return addToCart(event, item, variant);
        }
      }, "Add to Cart")));
    }) : /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, item.ProductId), /*#__PURE__*/React.createElement("td", null, item.DisplayName), /*#__PURE__*/React.createElement("td", null, item.Description), /*#__PURE__*/React.createElement("td", null, item.AdjustedPrice), /*#__PURE__*/React.createElement("td", null, item.AvailableInventory), /*#__PURE__*/React.createElement("td", null, item.StockStatusNameLong), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
      type: "button",
      disabled: item.AvailableInventory > 0 ? false : true,
      style: {
        float: 'right'
      },
      className: "cb-button-primary",
      onClick: function onClick(event) {
        return addToCart(event, item);
      }
    }, "Add to Cart")));
  })))))), /*#__PURE__*/React.createElement(OfflinePreview, props));
};

export default OfflineShop;